import {
  Action,
  Enum,
  PlainObject,
  State,
  Time,
  formatDistance,
  parseTimeFromArray
} from "@zyzgroup/core-common";

// 车场位置类型
export const XgParkLocationTypeEnum = new Enum({
  OUT_ROAD: { serverValue: "G", serverDescription: "路外" },
  IN_ROAD: { serverValue: "L", serverDescription: "路内" }
});

// 车场模式类型
export const XgParkModeTypeEnum = new Enum({
  ROBOT: { serverValue: "robot", serverDescription: "泊位机器人" },
  MANUAL: { serverValue: "manual", serverDescription: "人工" },
  ELF: { serverValue: "elf", serverDescription: "泊位精灵" }
});

// 车场配置模块类型
export const XgParkModuleTypeEnum = new Enum({
  XNY: { serverValue: "XNY", serverDescription: "新能源车缴费" },
  CJR: { serverValue: "CJR", serverDescription: "残疾人缴费" },
  DIS: { serverValue: "DIS", serverDescription: "车辆优惠券缴费" },
  WALLET: { serverValue: "WALLET", serverDescription: "小福泊车卡缴费" },
  RP: { serverValue: "RP", serverDescription: "用户上报车牌" },
  MONTH: { serverValue: "R", serverDescription: "路内包月" },
  INVOICE: { serverValue: "J", serverDescription: "开发票" }
});

function reduce(state: State, payload: PlainObject): State {
  state.tag = payload.tag ? String(payload.tag) : ""; // payload.tag 数据库中为 number
  // 车场模式类型
  state.taitype = payload.aitype || "";
  state.locationType = payload.ctype || "";
  // 名称
  state.name = payload.cname || "";
  // 地址
  state.addr = payload.addr || "";
  // 车场配置模块类型
  state.modules = payload.modules || [];
  // 客服电话
  state.phone = payload.phone || "";
  // 总车位数
  state.totallot = typeof payload.totallot == "number" ? payload.totallot : -1;
  // 空车位数
  state.freelot = typeof payload.freelot == "number" ? payload.freelot : -1;
  // 收费标准 图片链接
  state.feebookurl = payload.feebookurl || "";
  // 包月车位 图片链接
  state.monthlyscopeurl = payload.monthlyscopeurl || "";
  // 包月须知 html链接
  // 包月协议 html链接
  // 充电价格详情
  state.chargeFeeStandard = (payload.feedef || []).map((fd) => {
    return {
      startTime: parseTimeFromArray(fd[0]) as Time, // 24小时制-开始时间
      endTime: parseTimeFromArray(fd[1]) as Time, // 24小时制-结束时间
      chargeFee: fd[2], // 电费(单位分)
      serviceFee: fd[3] // 服务费(单位分)
    };
  });
  // 经度
  state.longitude =
    typeof payload.longitude == "number" ? payload.longitude : -1;
  // 纬度
  state.latitude = typeof payload.latitude == "number" ? payload.latitude : -1;
  state.distance = typeof payload.distance == "number" ? payload.distance : -1;
  state.thirdno = payload.thirdno || "";
  // 是否是机器人停车场
  state.isROBOT = state.aitype == XgParkModeTypeEnum.ROBOT;
  // 是否是人工停车场
  state.isMANUAL = state.aitype == XgParkModeTypeEnum.MANUAL;
  // 车场位置类型
  state.locationTypeFormatted = XgParkLocationTypeEnum.getName(
    state.locationType
  );
  // 当前距离
  state.distanceFormatted = state.distance
    ? formatDistance(state.distance)
    : "";
  // 查看包月车位：旧图片样式
  state.isShowMonthLotsPic = !!state.monthlyscopeurl;
  // UNDO: 查看包月车位：已采集车位GPS的地图样式
  state.isShowMonthLotsGPS = false;
  // 是否显示：查看包月车位
  // 如果配置为 `不显示` 或 `旧图片样式`：「办理包月详情页面顶部」显示地图，标注车场定位
  state.isShowMonthLots = state.isShowMonthLotsPic || state.isShowMonthLotsGPS;
  return state;
}

export default (immutable = true) =>
  (state: State, action: Action) => {
    const nextState: State = immutable ? { ...state } : state;
    const payload = action.payload || {};
    switch (action.type) {
      case "SET_PARK":
      case "INIT":
        // 初始化
        reduce(nextState, payload);
        break;
    }
    return nextState;
  };
